const selector = '[data-comp-hideable-element]';

export default class HideableElement {
  constructor(hiddenClass, parentEl) {
    this.element = parentEl.querySelector(selector);
    this.hiddenClass = hiddenClass;
  }

  /*
  * Hides/shows the element accordingly
  * @return {void}
  */
  hide() {
    this.element.classList.add(this.hiddenClass);
  }

  show() {
    this.element.classList.remove(this.hiddenClass);
  }
}
